module.exports = __webpack_public_path__ + "static/media/irs_rapid_relief.748e10db.png";